import React from 'react';
import { Link } from 'react-router';

class RRLink extends React.Component {
  onClickHandler = (ref) => {
    if (this.props.linkJSON.onClickHandler) {
      this.props.linkJSON.onClickHandler(ref);
    }
  }
  render() {
    if (!this.props.rrLink && !this.props.linkJSON) {
      return null;
    }
    const navLinkUrl = this.props.rrLink;
    let cssClass = '';
    let tabindex = '';
    let id = '';
    let href = 'javascript:void(0)';
    if (this.props.linkJSON && this.props.linkJSON.id) {
      id = this.props.linkJSON.id;
    }
    if (this.props.linkJSON && this.props.linkJSON.href) {
      href = this.props.linkJSON.href;
    }
    if (this.props.linkJSON && this.props.linkJSON.tabindex) {
      tabindex = this.props.linkJSON.tabindex;
    }
    if (this.props.linkJSON && this.props.linkJSON.cssClass) {
      cssClass = this.props.linkJSON.cssClass;
    }
    let anchorHtml = '';
    if (navLinkUrl) {
      anchorHtml = (<Link
        className={this.props.classname}
        to={navLinkUrl.route}
        // onClick={this.onClickHandler}
      >{this.props.children ? this.props.children : navLinkUrl.displayName}</Link>);
    } else if (!navLinkUrl && (this.props.isNotSamePage || this.props.linkJSON.isNotSamePage)) {
      anchorHtml = (<a
        id={id}
        onClick={(ref) => { this.onClickHandler(ref); }}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={cssClass}
        tabIndex={tabindex}
      > {this.props.children} </a>);
    } else {
      anchorHtml = (<a
        id={id}
        onClick={(ref) => { this.onClickHandler(ref); }}
        href={href}
        className={cssClass}
        tabIndex={tabindex}
      > {this.props.children} </a >);
    }
    return (
      anchorHtml
    );
  }
}

export default RRLink;
